import hasInstoreChannel from "client/utils/hasInstoreChannel";

import { Field } from "../../field";
import { FieldSet } from "../../fieldset";
import { Merchant } from "../../merchant";
import { Acquirer, CountryList, MerchantField } from "../../types";

const applicableCountries: CountryList[] = [
  "Australia",
  "New Zealand",
  "United Kingdom",
  "United States",
];

type CountryListPosProviderMap = {
  [key in CountryList]: Acquirer[];
};
/**
 * AU / NZ are the same. Consider extracting? Premature optimization?
 * What happens if they deviate? Obv we could spread common, but is
 * this desirable?
 */
export const countryListPosProviderMap: CountryListPosProviderMap = {
  Australia: [
    "Adyen",
    "ANZ",
    "Bank of Melbourne",
    "Bank of Queensland",
    "Bank SA",
    "Bankwest",
    "Bendigo Bank",
    "Checkout.com",
    "Citibank",
    "Commonwealth Bank",
    "Cuscal",
    "First Data",
    "Global Payments",
    "Macquarie Bank",
    "National Australia Bank",
    "PayPal Here",
    "St. George",
    "Suncorp",
    "Square",
    "Tyro",
    "Westpac",
    "Windcave",
    "Worldpay",
    "Other",
    "I don't know my Acquirer",
  ],
  Canada: [],
  "New Zealand": [
    "Adyen",
    "ANZ",
    "ASB",
    "BNZ",
    "Stripe",
    "Westpac",
    "Windcave",
    "Other",
    "I don't know my Acquirer",
  ],
  "United Kingdom": [
    "Paypal",
    "Shopify",
    "Worldpay",
    "Stripe",
    "Zettle",
    "Square",
    "Sage Pay",
    "PayPoint",
    "Streamline",
    "First Data",
    "Other",
  ],
  "United States": [
    "Adyen",
    "Chase Paymentech",
    "First Data",
    "Other",
    "Square",
    "Stripe",
    "Worldpay",
    // "Bank of America Merchant Services (BAMS)",
    // "Shopify",
  ],
};

export class AcquirerField extends Field<Acquirer> {
  constructor(
    model: Merchant,
    fieldSet: FieldSet<any>,
    opts: Partial<MerchantField<Acquirer>> = {}
  ) {
    super(
      model,
      {
        dataType: "string",
        propertyName: "acquirer",
        uiFieldType: "Select",
        ...opts,
      },
      fieldSet
    );
  }

  get applicable(): boolean {
    const registeredCountry = this._model.companyInformation.registeredCountry
      .value;
    const salesChannel = this._model.storeDetails.salesChannel.value;

    // base case
    if (!registeredCountry || !salesChannel) {
      return false;
    }

    if (applicableCountries.includes(registeredCountry)) {
      if (hasInstoreChannel(salesChannel)) {
        return true;
      }
    }
    return false;
  }

  get testValue(): Acquirer {
    const registeredCountry = this._model.companyInformation.registeredCountry
      .value;

    return registeredCountry
      ? countryListPosProviderMap[registeredCountry][0]
      : "Adyen";
  }

  get pickList(): Acquirer[] {
    const registeredCountry = this._model.companyInformation.registeredCountry
      .value;

    return registeredCountry
      ? countryListPosProviderMap[registeredCountry]
      : [];
  }

  get required(): boolean {
    return this.applicable;
  }

  get shown(): boolean {
    return this.applicable;
  }
}
